<template>
  <div class="choose">
    <div
      class="chooseItem"
      v-for="(item, index) in currentAnswerConfigArray"
      :key="index"
      @click.self="chooseEvent(index)"
    >
      <div class="row" @click="chooseEvent(index)">
        <span
          class="chooseIcon"
          :class="[
            { active: chooseArray.includes(index) },
            currentQuestionType,
          ]"
        ></span>
        <span class="text">{{ $filters.breakLine(translate[item.id]) }}</span>
      </div>
      <input
        class="input"
        :placeholder="$t('opinion')"
        v-model="commonAnswerInfo[index].edit"
        v-if="item.allowEdit && chooseArray.includes(index)"
        @click.stop.native=""
      />
      <img
        v-if="item.picUrl"
        class="previewPic"
        :src="item.picUrl"
        alt="previewPic"
      />
    </div>
  </div>
</template>
<script setup>
import answerHook from "../../hooks/answerHook";
const {
  currentAnswerConfigArray,
  chooseEvent,
  commonAnswerInfo,
  chooseArray,
  translate,
  currentQuestionType,
} = answerHook();
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.choose {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
  @media (orientation: landscape) {
    grid-column-gap: 20px;
  }
  @media (orientation: portrait) {
    grid-template-columns: 1fr;
  }
  .chooseItem {
    cursor: pointer;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-size: 26px;
    width: 100%;
    color: #000;
    margin-bottom: 30px;
    border-radius: 15px;
    box-sizing: border-box;
    @media (orientation: landscape) {
      font-size: 20px;
      margin-bottom: 30px;
      border-radius: 15px;
    }
    .row {
      display: flex;
      align-items: center;
    }
    .text {
      white-space: pre-wrap;
      word-break: break-word;
      line-height: 1.4;
    }
    .chooseIcon {
      margin-right: 15px;
      width: 35px;
      height: 35px;
      background-size: 100% 100% !important;
      flex: 1 0 auto;
      background-image: url($imgURL + "choose.png");
      transition: background-image 0.2s;
      &.active {
        background-image: url($imgURL + "choose_active.png");
      }
      @media (orientation: landscape) {
        width: 40px;
        height: 40px;
      }
    }
    .input {
      font-size: 14px;
      height: 40px;
      margin-top: 15px;
      padding-left: 15px;
      background: #fff;
      width: 100%;
      border-radius: 8px;
      box-shadow: 0px 0 4px #ccc;
      box-sizing: border-box;

      @media (orientation: landscape) {
        font-size: 14px;
        height: 40px;
        margin-top: 15px;
        padding-left: 10px;
        border-radius: 8px;
      }
    }
  }
}
</style>
